import { FunctionComponent } from 'react';
import { DebugMenuButtonProps } from './DebugMenuButtonProps';

export const DebugMenuButton: FunctionComponent<DebugMenuButtonProps> = ({ onClick }) => {
  return (
    <button
      className="px-4 py-1 text-white bg-orange-500 rounded-lg box-border shadow-lg hover:bg-opacity-60 active:bg-opacity-40"
      onClick={onClick}
    >
      Debug Menu
    </button>
  );
};
